export enum OrderPriceType {
    PURCHASE_PRICE,
    SELLING_PRICE,
    RECOMMENDED_PRICE,
}
